import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-zinc-950 text-zinc-300 mt-24">
      <div className="container-x mx-auto py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="text-overline text-zinc-500 mb-6">Ready to build</div>
            <h2 className="text-4xl sm:text-5xl font-black tracking-tighter leading-none text-white">
              The Intelligent<br />Enterprise.
            </h2>
            <p className="mt-6 text-zinc-400 max-w-md">
              Empowering industrial enterprises with intelligent, sustainable,
              and future-ready solutions across AI, Cloud, and Automation.
            </p>
            <Link
              to="/contact"
              data-testid="footer-request-demo-btn"
              className="inline-flex items-center gap-2 mt-8 bg-white text-zinc-950 px-6 py-3 text-sm font-semibold hover:bg-zinc-200 transition-colors"
            >
              Request a Demo <ArrowUpRight size={16} weight="bold" />
            </Link>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <div className="text-overline text-zinc-500 mb-4">Company</div>
              <ul className="space-y-3 text-sm">
                <li><Link to="/about" className="hover:text-white transition">Why Bizlem</Link></li>
                <li><Link to="/blueprint" className="hover:text-white transition">Blueprint</Link></li>
                <li><Link to="/architecture" className="hover:text-white transition">Architecture</Link></li>
                <li><Link to="/contact" className="hover:text-white transition">Contact</Link></li>
              </ul>
            </div>
            <div>
              <div className="text-overline text-zinc-500 mb-4">Solutions</div>
              <ul className="space-y-3 text-sm">
                <li><Link to="/solutions#metals" className="hover:text-white transition">Metals & Steel</Link></li>
                <li><Link to="/solutions#mining" className="hover:text-white transition">Mining</Link></li>
                <li><Link to="/solutions#construction" className="hover:text-white transition">Construction</Link></li>
                <li><Link to="/solutions#manufacturing" className="hover:text-white transition">Manufacturing</Link></li>
                <li><Link to="/solutions#realty" className="hover:text-white transition">Realty & Facilities</Link></li>
                <li><Link to="/solutions#education" className="hover:text-white transition">Education</Link></li>
                <li><Link to="/solutions#agriculture" className="hover:text-white transition">Agriculture</Link></li>
              </ul>
            </div>
            <div>
              <div className="text-overline text-zinc-500 mb-4">Platforms</div>
              <ul className="space-y-3 text-sm">
                <li><Link to="/platforms" className="hover:text-white transition">AI Manufacturing Suite</Link></li>
                <li><Link to="/platforms" className="hover:text-white transition">AI Mining Platform</Link></li>
                <li><Link to="/platforms" className="hover:text-white transition">Smart Facility Platform</Link></li>
                <li><Link to="/platforms" className="hover:text-white transition">AI Procurement Portal</Link></li>
                <li><Link to="/platforms" className="hover:text-white transition">AI Command Center</Link></li>
                <li><Link to="/platforms" className="hover:text-white transition">Intelligent Analytics</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-zinc-800 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src="/bizlem-logo.png"
              alt="Bizlem"
              className="h-8 w-auto object-contain"
            />
            <span className="text-zinc-500 text-xs">© {year} — All rights reserved.</span>
          </div>
          <a
            href="mailto:info@bizlem.com"
            data-testid="footer-email-link"
            className="text-sm font-mono text-zinc-400 hover:text-white transition"
          >
            info@bizlem.com
          </a>
        </div>
      </div>
    </footer>
  );
}
